import { UiSwitchModule } from 'ngx-ui-switch';
import { SystemSettingsComponent } from './system-settings/system-settings.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidatedInputFieldModule, ConfirmModalModule, ErrorContainerModule, TableModule, ErrorShowingModule } from 'ccc-commons/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'system',
    component: SystemSettingsComponent,
  }
];



@NgModule({
  declarations: [SystemSettingsComponent],
  imports: [
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgSelectModule,
    NgbDatepickerModule,
    ConfirmModalModule,
    NgbDropdownModule,
    ValidatedInputFieldModule,
    ErrorContainerModule,
    TableModule,
    UiSwitchModule,
    ErrorShowingModule,
    RouterModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class SettingsModule { }
